import React from 'react'
import $t from '../../../i18n'

import './AnimatedLoadingLabel.css'

const AnimatedLoadingLabel = ({
  loadingText = $t('chat.loading'),
  dark = false,
}) => {
  return (
    <span className={`loading-text${dark ? ' dark' : ''}`}>
      {loadingText}...
    </span>
  )
}

export default AnimatedLoadingLabel
